import { render, staticRenderFns } from "./EmbedCourse.vue?vue&type=template&id=8dbfb524&scoped=true"
import script from "./EmbedCourse.vue?vue&type=script&lang=js"
export * from "./EmbedCourse.vue?vue&type=script&lang=js"
import style0 from "../styles/EmbedCourse.css?vue&type=style&index=0&id=8dbfb524&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbfb524",
  null
  
)

export default component.exports